var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-event-hotelsBlock"},[_c('HotelList',{attrs:{"hotels":_vm.hotels,"list":_vm.list,"title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }